'use strict';
(function (angular) {
	function Controller($element, $attrs) {
		this.rootClasses = [];

		this.$onInit = () => {
			if (angular.isDefined($attrs.pmtTitleBarTransparent)) {
				this.rootClasses.push('pmt-title-bar--transparent');
			}
		};
	}
	angular.module('PinMeTo.UI').component('pmtTitleBar', {
		templateUrl: 'pmtShared/pmtUi/TitleBar.html',
		transclude: {
			title: 'pmtTitleBarTitle',
			asides: '?pmtTitleBarAsides'
		},
		bindings: {
			faClasses: '@'
		},
		controller: Controller
	});

	Controller.$inject = ['$element', '$attrs'];
})(window.angular);
